import MasterDataPage from './MasterDataPage';

export default MasterDataPage;
